import React, { useEffect, useState } from 'react';
import { useProperty } from '../../hooks/useProperty';
// import PrintableReport from './PrintableReport'; doesn't work for now (the reports are not correct), need to add back later
import classNames from '../../utility/classNames';
import { FORMS, PAGES } from '../../schemas/stepMap';
import { Icon, LeftColumn, Logo, PageLoader } from '../../components';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IconButton } from '../../components';
import formatAddress from '../../utility/formatAddress';
import pdfIcon from '../../assets/pdf.svg';
import getCurrentDateFormatted from '../../utility/dates';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import toast from 'react-hot-toast';
import Tooltip from '../../components/Tooltip';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase/clientApp';
import { useUser } from '../../hooks/useUser';

export default function SummaryPage() {
  // const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useUser();
  const sharing = pathname.includes('sharing');
  const { loading, error, propertyData, scenarios } = useProperty();
  const navigate = useNavigate();
  const [printing, setPrinting] = useState(false);
  if (propertyData?.projectType === 'flip') {
    navigate('../flip-analysis');
  }

  const pages = [
    FORMS.purchaseAnalysis,
    FORMS.BuyAndHoldAnalysis,
    FORMS.BRRRRAnalysis,
  ];

  // improve this

  function printPDF() {
    setPrinting(true);
    setTimeout(() => {
      generate();
    }, 0);
  }

  function logExport() {
    const reportType = (currentTab.name ?? '')
      .replaceAll(' ', '_')
      .toLowerCase();
    logEvent(analytics, `${reportType}_exported`, {
      user_id: user?.uid,
      property_id: propertyData?.propertyId,
    });
  }

  function generate() {
    setPrinting(true);
    const element = document.getElementById('page-summary');

    if (!element) {
      setPrinting(false);
      return;
    }

    try {
      const clonedElement = element.cloneNode(true);
      clonedElement.style.position = 'absolute';
      clonedElement.style.top = '-9999px';
      clonedElement.style.left = '-9999px';
      clonedElement.classList.add('printing');
      clonedElement.classList.add('p-8');
      clonedElement.style.width = '1080px';
      const h = document.getElementById('printable-header');

      const header = h.cloneNode(true);

      header.classList.remove('hidden');
      header.classList.add('grid');
      clonedElement.insertBefore(header, clonedElement.firstChild);

      document.body.appendChild(clonedElement);

      html2canvas(clonedElement, {
        scale: 2,
      }).then((canvas) => {
        const componentWidth = clonedElement.offsetWidth;
        const componentHeight = clonedElement.offsetHeight;

        document.body.removeChild(clonedElement);

        const orientation = componentWidth >= componentHeight ? 'l' : 'p';

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation,
          unit: 'px',
        });

        pdf.internal.pageSize.width = componentWidth;
        pdf.internal.pageSize.height = componentHeight;

        pdf.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight);
        const fileName = `${propertyData.propertyName} - ${
          currentTab.name
        } - ${getCurrentDateFormatted()}`;

        pdf.save(`${fileName}.pdf`);
        toast.success('PDF downloaded', { position: 'bottom-right' });
        setPrinting(false);
        logExport();
      });
    } catch (error) {
      console.log('Failed to print the PDF', error);
      setPrinting(false);
      element.style.width = 'auto';
      toast.error('Something went wrong', { position: 'bottom-right' });
    }
  }

  if (sharing) {
    pages.push(PAGES.rentRoll, FORMS.projection, FORMS.cashFlow);
  }

  const tabs = pages.map((page) => {
    return { ...page, pathName: page.pathName.split('/').at(-1) };
  });

  const currentTabName = pathname.split('/').at(-1);

  const currentTab =
    tabs.find((tab) => {
      return (
        tab.pathName === currentTabName ||
        (tab.pathName === 'comparison' && currentTabName === 'projections') ||
        (tab.pathName === 'comparison' && currentTabName === 'cash-flow')
      );
    }) || tabs[0];

  // Show alert when refinancing options are available
  const [refinancing, setRefinancing] = useState(false);

  useEffect(() => {
    const scenariosWitpathnameinancing = scenarios.filter(
      (scenario) => scenario.refinancingCashOut >= 50000
    );

    setRefinancing(scenariosWitpathnameinancing.length > 0);
  }, [scenarios]);

  if (loading) {
    return (
      <LeftColumn fullWidth>
        <PageLoader />
      </LeftColumn>
    );
  }

  if (error && error.length) {
    return <Error error={error} />;
  }

  return (
    <section className="relative">
      {/* {!sharing && (
        <PropertyPageHeader
          title="Summary"
       
        />
      )} */}

      <div id="printable-header" className="grid-cols-4 p-4 hidden">
        <div className="flex items-center justify-start">
          <Logo variant="dark" size="md" />
        </div>
        <div className="col-span-2 flex items-center justify-center">
          <h1 className="text-center text-4xl font-medium font-serif text-neutral-900">
            {propertyData.propertyName} -{' '}
            {currentTab.summaryPageTitle || currentTab.name}
          </h1>
        </div>
        <div className="text-right text-md">
          <p>PropertyCast.io</p>
          <p>{formatAddress(propertyData.propertyAddress, 'short')}</p>
          <br />
          <p>{getCurrentDateFormatted()}</p>
        </div>
      </div>

      <div className="block">
        <div className=" border-spacing-4">
          <nav
            className="hidden -mb-px sm:flex space-x-4 justify-between flex-wrap mt-2"
            aria-label="Tabs"
          >
            <div className="flex justify-start space-x-4">
              <h1 className="text-4xl font-medium font-serif text-neutral-900">
                {currentTab.summaryPageTitle || currentTab.name}
              </h1>
              {/* {tabs.map((tab) => {
                const isCurrent = currentTab.pathName === tab.pathName;

                return (
                  <Link
                    key={tab.pathName}
                    to={tab.pathName}
                    className={classNames(
                      isCurrent
                        ? 'border-primary text-white bg-primary-800 hover:bg-primary-500'
                        : 'border-neutral-200 text-neutral-500 hover:border-neutral-300 bg-white/50 hover:text-white hover:bg-primary-500  ',
                      'whitespace-nowrap rounded-md p-2 mb-2 text-md font-medium border tracking-wide'
                    )}
                    aria-current={isCurrent ? 'page' : undefined}
                  >
                    {tab.number && (
                      <span className="text-xs font-semibold">
                        {tab.number + ' - '}
                      </span>
                    )}
                    {tab.name}
                  </Link>
                );
              })} */}
            </div>
            <div className="flex items-center gap-4">
              <Tooltip
                delay={true}
                text="Download the current summary in PDF format."
              >
                <button
                  className="transition inline-flex justify-center gap-[4px] items-center h-[39px] py-1.5 px-2  border border-transparent  text-md font-medium rounded-md text-white bg-primary hover:bg-primary-500 focus:bg-primary-500 focus:outline-none disabled:bg-neutral-200 disabled:cursor-not-allowed"
                  onClick={printPDF}
                >
                  <span className="sr-only">Download PDF</span>
                  {printing ? (
                    <Icon
                      icon="BiLoaderAlt"
                      className="text-xl animate-spin h-5 w-5"
                    ></Icon>
                  ) : (
                    <img
                      className="h-5 w-5 text-white"
                      src={pdfIcon}
                      alt="pdf icon"
                    />
                  )}
                </button>
              </Tooltip>

              {!sharing && currentTab && (
                <Link to={`../${currentTab.formPathName}` || ''}>
                  <IconButton
                    style="primary"
                    text="Adjust Worksheet"
                    classes="py-[8px] min-w-[12rem]"
                  />
                </Link>
              )}
            </div>
          </nav>
          <nav
            className="grid xs:grid-cols-2 -mb-px sm:hidden space-x-4 space-y-4 xs:space-y-0  pt-4 justify-center flex-wrap"
            aria-label="Tabs"
          >
            <div
              className={classNames(
                'flex flex-col gap-3',
                !sharing && 'col-span-2 text-center'
              )}
            >
              {sharing && (
                <h3 className="font-medium tracking-wide text-md text-neutral-700 border-b pb-1">
                  Analysis
                </h3>
              )}
              <div className="flex flex-col gap-2">
                {tabs?.slice(0, 3).map((tab) => {
                  const isCurrent = currentTab.pathName === tab.pathName;

                  return (
                    <Link
                      key={tab.pathName}
                      to={tab.pathName}
                      className={classNames(
                        isCurrent
                          ? ' bg-primary focus:bg-primary text-white'
                          : 'border border-neutral-200 text-neutral-500  focus:bg-neutral-500',
                        'whitespace-nowrap shadow-sm rounded py-2 px-2 text-base font-medium'
                      )}
                      aria-current={isCurrent ? 'page' : undefined}
                    >
                      {tab.number && (
                        <span className="text-xs font-semibold">
                          {tab.number + ' - '}
                        </span>
                      )}
                      {tab.name}
                    </Link>
                  );
                })}
              </div>
            </div>

            {sharing && (
              <div className="flex flex-col gap-3">
                <h3 className="font-medium tracking-wide text-md text-neutral-700 border-b pb-1">
                  More
                </h3>
                <div className="flex flex-col gap-2 items-end">
                  {tabs?.slice(3, 7).map((tab) => {
                    const isCurrent = currentTab.pathName === tab.pathName;

                    return (
                      <Link
                        key={tab.pathName}
                        to={tab.pathName}
                        className={classNames(
                          isCurrent
                            ? 'border-primary text-primary'
                            : 'border-transparent text-neutral-500 focus:border-neutral-300 focus:text-neutral-700',
                          'whitespace-nowrap border-2 rounded w-full py-[6px] px-1 text-base font-medium'
                        )}
                        aria-current={isCurrent ? 'page' : undefined}
                      >
                        {tab.name}
                      </Link>
                    );
                  })}
                </div>
              </div>
            )}
          </nav>
        </div>
      </div>
      <Outlet context={{ propertyData, scenarios }} />

      {/* {!sharing && user && <PrintableReport />} */}
    </section>
  );
}
